import { Button, Modal } from "antd";
import "./ResendInvitesModal.scss";

interface ResendInvitesModalProps {
  open: boolean;
  count: number;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ResendInvitesModal({ open, count, loading, onCancel, onConfirm }: ResendInvitesModalProps) {
  return (
    <Modal className={"resend-invites-modal clean"} open={open} onCancel={onCancel}>
      <header>
        <h2>Resend all pending invitations?</h2>
      </header>

      <p>
        Invitation emails will be resent to <strong>{count} {count === 1 ? "user" : "users"}</strong> with pending invites.
      </p>

      <footer>
        <Button size={"large"} onClick={onCancel}>Cancel</Button>
        <Button size={"large"} className={"primary"} loading={loading} onClick={onConfirm}>
          Resend {count} {count === 1 ? "Invitation" : "Invitations"}
        </Button>
      </footer>
    </Modal>
  );
}
